import React, { useState } from 'react';
import seoData from '../data/seo.json';

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="container mx-auto px-4 py-16">
            <div className="mx-auto animate-fade-in opacity-0">
                <h2 className="text-3xl font-bold mb-4 text-center text-text-dark">
                    Frequently Asked Questions
                </h2>
                <p className="text-text-light text-center mb-10">
                    Common questions about our plumbing and heating services in Calgary
                </p>

                <div className="space-y-4">
                    {seoData.faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="glass-panel overflow-hidden"
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full px-6 py-5 text-left flex justify-between items-center hover:bg-white/30 transition-colors"
                            >
                                <span className="font-semibold text-text-dark pr-4">{faq.question}</span>
                                <span className={`text-primary-blue text-2xl transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                                    +
                                </span>
                            </button>
                            <div
                                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <p className="px-6 pb-5 text-text-light">
                                    {faq.answer}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;

